const infraServices = [
  { name: 'Docker', status: 'ok', icon: 'ri-ship-2-line' },
  { name: 'PostgreSQL', status: 'ok', icon: 'ri-database-2-line' },
  { name: 'Redis', status: 'ok', icon: 'ri-database-line' },
  { name: 'Nginx', status: 'ok', icon: 'ri-globe-line' },
  { name: 'Evolution API', status: 'ok', icon: 'ri-whatsapp-line' },
  { name: 'Node.js', status: 'ok', icon: 'ri-nodejs-line' },
  { name: 'Certbot (SSL)', status: 'ok', icon: 'ri-shield-check-line' },
  { name: 'UFW (Firewall)', status: 'ok', icon: 'ri-shield-line' },
];

const serverMetrics = [
  { label: 'CPU', value: 'AMD EPYC 7713 (4 vCPUs)', icon: 'ri-cpu-line' },
  { label: 'RAM', value: '8 GB DDR4', icon: 'ri-hard-drive-line' },
  { label: 'SSD', value: '160 GB NVMe', icon: 'ri-hard-drive-2-line' },
  { label: 'Sistema', value: 'Ubuntu 24.04 LTS', icon: 'ri-ubuntu-line' },
  { label: 'Kernel', value: '6.8.0-31-generic', icon: 'ri-terminal-box-line' },
  { label: 'Uptime', value: '47 dias, 3 horas', icon: 'ri-timer-line' },
];

export default function SettingsInfrastructurePage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-heading font-bold text-foreground-950">Infraestrutura</h2>
        <p className="text-sm text-foreground-500 mt-1">Status do servidor e serviços em execução</p>
      </div>

      {/* Server Info */}
      <div className="bg-background-100 rounded-2xl border border-background-200 p-5">
        <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-4">Servidor</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {serverMetrics.map((m) => (
            <div key={m.label} className="flex items-center gap-3 p-3 rounded-xl bg-background-50">
              <div className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0">
                <i className={`${m.icon} text-foreground-600 text-lg`} />
              </div>
              <div className="min-w-0">
                <p className="text-[11px] text-foreground-500">{m.label}</p>
                <p className="text-xs font-semibold text-foreground-900 truncate">{m.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Services Status */}
      <div className="bg-background-100 rounded-2xl border border-background-200 p-5">
        <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-4">Serviços</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {infraServices.map((svc) => (
            <div key={svc.name} className="flex items-center gap-3 p-3 rounded-xl border border-background-200 hover:border-emerald-200 transition-colors">
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${svc.status === 'ok' ? 'bg-emerald-50' : 'bg-red-50'}`}>
                <i className={`${svc.icon} ${svc.status === 'ok' ? 'text-emerald-600' : 'text-red-500'} text-lg`} />
              </div>
              <div className="min-w-0">
                <p className="text-xs font-semibold text-foreground-900">{svc.name}</p>
                <div className="flex items-center gap-1.5">
                  <span className={`w-1.5 h-1.5 rounded-full ${svc.status === 'ok' ? 'bg-emerald-500' : 'bg-red-500'}`} />
                  <span className={`text-[11px] font-medium ${svc.status === 'ok' ? 'text-emerald-600' : 'text-red-500'}`}>
                    {svc.status === 'ok' ? 'Online' : 'Offline'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Network info */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-background-100 rounded-xl border border-background-200 p-4">
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-cloud-fill text-emerald-500 text-lg" />
            <p className="text-xs font-semibold text-foreground-600">Cloudflare</p>
          </div>
          <p className="text-sm font-semibold text-emerald-600">Ativo</p>
          <p className="text-[11px] text-foreground-500">DNS + Proxy</p>
        </div>
        <div className="bg-background-100 rounded-xl border border-background-200 p-4">
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-shield-check-line text-emerald-500 text-lg" />
            <p className="text-xs font-semibold text-foreground-600">SSL</p>
          </div>
          <p className="text-sm font-semibold text-emerald-600">Válido</p>
          <p className="text-[11px] text-foreground-500">Expira em 87 dias</p>
        </div>
        <div className="bg-background-100 rounded-xl border border-background-200 p-4">
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-wifi-line text-emerald-500 text-lg" />
            <p className="text-xs font-semibold text-foreground-600">Rede</p>
          </div>
          <p className="text-sm font-semibold text-foreground-900">1 Gbps</p>
          <p className="text-[11px] text-foreground-500">Tráfego: 2.3 TB/mês</p>
        </div>
      </div>
    </div>
  );
}